/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Aero } from './Aero';
import type { AncillaryLoad } from './AncillaryLoad';
import type { ComponentConfigurationSet } from './ComponentConfigurationSet';
import type { DecelerationLimit } from './DecelerationLimit';
import type { DriveCycle } from './DriveCycle';
import type { Mass } from './Mass';
import type { WheelInput } from './WheelInput';
/**
 * Drive Cycle Requirement Populated From Database.
 */
export type DriveCycleRequirement = {
    item_type?: DriveCycleRequirement.item_type;
    name?: string;
    description?: string;
    mass?: Mass;
    aero?: Aero;
    wheel?: WheelInput;
    deceleration_limit?: (DecelerationLimit | null);
    state_of_charge?: number;
    component_configurations?: ComponentConfigurationSet;
    ambient_temperature?: number;
    thermal_analysis?: boolean;
    shift_delta?: number;
    stop_at_temperature_limit?: boolean;
    requirement_input_type?: DriveCycleRequirement.requirement_input_type;
    requirement_type?: DriveCycleRequirement.requirement_type;
    solver_id?: number;
    drive_cycle: DriveCycle;
    range?: (number | null);
    full_range_calculation?: boolean;
    ancillary_load?: (AncillaryLoad | null);
};
export namespace DriveCycleRequirement {
    export enum item_type {
        REQUIREMENT = 'requirement',
    }
    export enum requirement_input_type {
        DRIVE_CYCLE = 'drive_cycle',
    }
    export enum requirement_type {
        DRIVE_CYCLE = 'drive_cycle',
    }
}

